import React from "react";

const TermsOfUse = () => (
  <div
    style={{
      maxWidth: 800,
      margin: "2rem auto",
      padding: "2rem",
      background: "#fff",
      color: "#222",
      borderRadius: 12,
      boxShadow: "0 4px 24px #0001",
      fontFamily: "Inter, Arial, sans-serif",
      lineHeight: 1.7,
    }}
  >
    <h1
      style={{
        fontSize: "2.2rem",
        fontWeight: 800,
        marginBottom: "1.5rem",
        color: "#7C3AED",
      }}
    >
      Terms of Use
    </h1>
    <p style={{ color: "#666", fontSize: "1rem", marginBottom: "1.5rem" }}>
      <strong>Last Updated:</strong> [10, 2025]
    </p>

    <p>
      Welcome to BitcoinFOMO (“Company,” “we,” “our,” or “us”). By accessing or
      using our website at bitcoinfomo.io and any related sub-domains
      (collectively, the “Site”), you agree to be bound by these Terms of Use
      (“Terms”). If you do not agree, please do not use the Site.
    </p>

    <h2 style={{ marginTop: "2rem", color: "#A855F7", fontSize: "1.3rem" }}>
      1. Use of the Site
    </h2>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>
        The Site is provided for informational purposes only to share project
        updates and collect email addresses for optional updates.
      </li>
      <li>
        You must be at least 18 years old (or the age of majority in your
        jurisdiction) to use the Site.
      </li>
      <li>
        You agree not to use the Site for any unlawful purpose or in violation
        of these Terms.
      </li>
    </ul>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      2. No Offer or Investment Advice
    </h2>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>
        Nothing on this Site constitutes an offer to sell or a solicitation to
        buy any cryptocurrency, security, or financial instrument.
      </li>
      <li>
        Content is provided “as is” without investment, financial, or legal
        advice.
      </li>
      <li>
        Any references to potential future tokens, features, or launches are
        preliminary and subject to change.
      </li>
    </ul>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      3. Privacy
    </h2>
    <p>
      Your use of the Site is also governed by our Privacy Policy, which
      explains how we collect and use information, including email addresses
      submitted through our sign-up form.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      4. Intellectual Property
    </h2>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>
        All content on the Site—including text, graphics, logos, and designs—is
        owned by or licensed to BitcoinFOMO and protected by applicable
        intellectual-property laws.
      </li>
      <li>
        You may view or print content for personal, non-commercial use only.
      </li>
      <li>
        You may not copy, modify, distribute, or create derivative works without
        our prior written consent.
      </li>
    </ul>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      5. User Submissions
    </h2>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>
        By submitting your email or other information, you represent that it is
        accurate and that you have the right to provide it.
      </li>
      <li>
        You grant us a non-exclusive, worldwide license to use the submitted
        email solely to send project updates and related communications.
      </li>
    </ul>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      6. Third-Party Services & Links
    </h2>
    <p>
      The Site may contain links to third-party websites or services. We are not
      responsible for the content, privacy policies, or practices of any third
      parties.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      7. Disclaimers
    </h2>
    <ul style={{ marginLeft: "1.5rem", marginBottom: "1rem" }}>
      <li>
        The Site is provided on an “as is” and “as available” basis without
        warranties of any kind, express or implied.
      </li>
      <li>
        We do not warrant that the Site will be uninterrupted, error-free, or
        secure.
      </li>
    </ul>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      8. Limitation of Liability
    </h2>
    <p>
      To the fullest extent permitted by law, BitcoinFOMO and its affiliates
      shall not be liable for any indirect, incidental, special, or
      consequential damages arising from or related to your use of the Site.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      9. Indemnification
    </h2>
    <p>
      You agree to indemnify and hold harmless BitcoinFOMO, its affiliates, and
      their respective officers, employees, and agents from any claims or
      demands arising out of your use of the Site or violation of these Terms.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      10. Changes to the Terms
    </h2>
    <p>
      We may update these Terms from time to time. Material changes will be
      posted on this page with a new “Last Updated” date. Your continued use of
      the Site after changes constitutes acceptance of the revised Terms.
    </p>

    <h2 style={{ marginTop: "1.5rem", color: "#A855F7", fontSize: "1.3rem" }}>
      11. Governing Law
    </h2>
    <p>
      These Terms are governed by the laws of the State of New York, without
      regard to its conflict-of-laws principles. Any disputes will be resolved
      exclusively in the courts located in New York.
    </p>
  </div>
);

export default TermsOfUse;
